// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OperationsRouteImport } from './routes/operations'
import { Route as FootprintRouteImport } from './routes/footprint'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ArchitectureRouteImport } from './routes/architecture'
import { Route as IndexRouteImport } from './routes/index'

const OperationsRoute = OperationsRouteImport.update({
            id: '/operations',path: '/operations',getParentRoute: () => rootRouteImport
          })
const FootprintRoute = FootprintRouteImport.update({
            id: '/footprint',path: '/footprint',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ArchitectureRoute = ArchitectureRouteImport.update({
            id: '/architecture',path: '/architecture',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ArchitectureRoute: ArchitectureRoute,ContactRoute: ContactRoute,FootprintRoute: FootprintRoute,OperationsRoute: OperationsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)